class DataCenterLog {
  static send({
    cmd = 9010,
    item = '',
    action = '',
    /* eslint-disable camelcase */
    page_id = '',
    /* eslint-enable camelcase */
    pos = '',
    uid = '',
  }) {
    // let path = 'http://log.1sapp.com/a.gif?';
    let query = [];
    let arg = arguments[0] || {};
    let option = {
      cmd,
      item,
      action,
      page_id,
      pos,
      uid,
      ...arg,
    };
    // eslint-disable-next-line guard-for-in
    for (let key in option) {
      query.push(`${key}=${option[key]}`);
    }
    // new Image().src = path + query.join('&');
  }
}

export default DataCenterLog;
